export interface IEmergencyCategories {
  description?: string;
  image_name?: string;
  selected?: boolean;
}

export interface IEmergencyMailPayload {
  email: string;
  brolink_id: string;
  service: string;
  user_id: string;
  insurer: string;
  policy_id: string;
  broker_email: string;
  timestamp: string;
}
